module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_8004.a25c1406.png";